import React from 'react';
export function Footer() {
  return <footer className="w-full bg-white border-t border-line py-14 px-4" data-id="element-131" data-mp="32wd2cf6gdjt0">
      <div className="max-w-4xl mx-auto text-center" data-id="element-132" data-mp="3ggaqtvj9sd5g">
        <div className="text-rose font-bold tracking-[0.18em] text-xs mb-3 uppercase" data-id="element-133" data-mp="3gh3ng3oilm9v">
          🌸 Aula Mater™
        </div>
        <h3 className="font-serif font-bold text-2xl md:text-3xl text-ink mb-4 uppercase tracking-tight" data-id="element-134" data-mp="36oy0j8d4dv1j">
          Aula Mater
        </h3>
        <p className="text-ink-soft max-w-2xl mx-auto text-sm md:text-base leading-relaxed mb-8" data-id="element-135" data-mp="3ufjvbxy45itl">
          Contenido educativo y herramientas prácticas para mejorar tu bienestar
          emocional. Porque proteger tu paz mental no debería postergarse por
          falta de un método claro y aplicable.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mb-10 text-sm text-ink" data-id="element-136" data-mp="3qfjhofiu9bnl">
          <span className="flex items-center gap-2" data-id="element-137" data-mp="2eya0y0r3gxpz">
            📧{' '}
            <span className="font-medium select-all" data-id="element-138" data-mp="2ew6zmkkhri5y">
              soporteaulamater@gmail.com
            </span>
          </span>
          <span className="hidden sm:inline text-line" data-id="element-139" data-mp="3gapbneqg0cdv">|</span>
          <span className="flex items-center gap-2" data-id="element-140" data-mp="3gca6l5go5xc9">
            📲 Instagram:{' '}
            <span className="font-medium select-all" data-id="element-141" data-mp="3v9b1tiy2kafh">@aulamater_</span>
          </span>
          <span className="hidden sm:inline text-line" data-id="element-142" data-mp="3q7u1bojhypzf">|</span>
          <span className="flex items-center gap-2" data-id="element-143" data-mp="82qtvx6261vu">
            📘 Facebook:{' '}
            <span className="font-medium select-all" data-id="element-144" data-mp="80nvopur52g1">Aula Mater</span>
          </span>
        </div>

        <div className="border-t border-line pt-6 text-xs text-muted leading-relaxed max-w-2xl mx-auto" data-id="element-145" data-mp="hstv2knc2m59">
          © {new Date().getFullYear()} Aula Mater™ — Todos los derechos
          reservados. Prohibida la reproducción y redistribución sin
          autorización expresa. Este material tiene fines informativos y de
          bienestar personal. No reemplaza el diagnóstico ni el tratamiento
          profesional.
        </div>
        <div className="font-serif-italic text-rose text-base mt-6" data-id="element-146" data-mp="tvw8ij57pjh1">
          🌸 "Tu paz mental también merece protección."
        </div>
      </div>
    </footer>;
}